<template>
	<Button link pronto :to="{ name: 'mainsettings', params: { id: userId } }">
		<ChevronIcon type="regular" left />
		<span v-t="'settings_title'" />
	</Button>
</template>

<script>
import { Button } from '@/components/common'
import { ChevronIcon } from '@/icons'
import store from '@/store'

export default {
	name: 'BackToSettings',
	components: { Button, ChevronIcon },
	data() {
		return { userId: store.auth.user.id }
	},
}
</script>

<style lang="scss" scoped>
.pronto-btn {
	position: absolute;
	top: 8px;
	left: 8px;
	font-size: 18px;
}
.pronto-icon {
	margin-right: 8px;
}
</style>
